export default "__VITE_ASSET__CUSXGRtE__"